// import React from 'react';
// import { FaGooglePlay, FaInstagram, FaWhatsapp, FaFacebookF, FaLinkedinIn, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
// import { Link } from 'react-router-dom';
// import '../styles/Footer.css';

// const Footer = () => {
//   return (
//     <footer className="footer">
//       <div className="container">
//         <div className="footer-content">
//           <div className="footer-section">
//             <img src="/images/flyhubicon.svg" alt="FlyHub Logo" className="footer-logo" />
//             <p className="footer-description">
//               Your one-stop solution for all drone-related needs. Marketplace, services, jobs, and training.
//             </p>
//             <div className="social-icons">
//               <a href="https://www.instagram.com/flyhub_info?igsh=OWM2a3E2Ym81bzRs" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
//                 <FaInstagram />
//               </a>
//               <a href="https://whatsapp.com/channel/0029VbCWqYHJP219qPZVns0P" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="WhatsApp">
//                 <FaWhatsapp />
//               </a>
//               <a href="https://www.facebook.com/share/1A8fBiqxmt/'" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
//                 <FaFacebookF />
//               </a>
//               <a href="https://www.linkedin.com/company/flyhubinfo/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
//                 <FaLinkedinIn />
//               </a>
//             </div>
//           </div>

//           <div className="footer-section">
//             <h4>Quick Links</h4>
//             <ul>
//               <li><Link to="/">Home</Link></li>
//                <li><Link to="/franchise">Franchise</Link></li>
//               <li><Link to="/features">Features</Link></li>
//               <li><Link to="/categories">Categories</Link></li>
//               <li><Link to="/about-us">About Us</Link></li>
//                 <li><Link to="/contact">Contact</Link></li>
//             </ul>
//           </div>

//           <div className="footer-section">
//             <h4>Contact & Legal</h4>
//             <ul>
//               <li className="contact-item">
//                 <FaEnvelope className="contact-icon" />
//                 <span>info@flyhub.com</span>
//               </li>
//               <li className="contact-item">
//                 <FaPhone className="contact-icon" />
//                 <span>+91 9003992693</span>
//               </li>
//               <li className="contact-item">
//                 <FaMapMarkerAlt className="contact-icon" />
//                 <span>Manickampalayam, Tiruchengode, Tamil Nadu 637202</span>
//               </li>
//               <li className="legal-links">
//                 <Link to="/terms">Terms & Conditions</Link>
//                 <span className="separator">|</span>
//                 <Link to="/privacy">Privacy Policy</Link>
//               </li>
//             </ul>
//           </div>

//           <div className="footer-section">
//             {/* <h4>Get Our App</h4> */}
//             {/* <a href="https://play.google.com/store" target="_blank" rel="noopener noreferrer" className="google-play-link">
//               <div className="google-play-badge">
//                 <FaGooglePlay className="google-play-icon" />
//                 <div className="google-play-text">
//                   <span className="google-play-small">GET IT ON</span>
//                   <span className="google-play-large">Google Play</span>
//                 </div>
//               </div>
//             </a> */}
//           </div>
//         </div>


//         <div className="footer-bottom">
//           <p>&copy; 2025 Flyhub. All rights reserved.</p>
//           <p className="design-credit">Designed for drone enthusiasts and professionals</p>
//         </div>
//       </div>
//     </footer>
//   );
// };

// export default Footer;




import React from 'react';
import { FaInstagram, FaWhatsapp, FaFacebookF, FaLinkedinIn, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <img src="/flyHub_logo.svg" alt="FlyHub Logo" className="footer-logo" />
            <p className="footer-description">
              Your one-stop solution for all drone-related needs. Marketplace, services, jobs, and training.
            </p>
            <div className="social-icons">
              <a href="https://www.instagram.com/flyhub_info?igsh=OWM2a3E2Ym81bzRs" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://whatsapp.com/channel/0029VbCWqYHJP219qPZVns0P" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
              <a href="https://www.facebook.com/share/1A8fBiqxmt/'" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a href="https://www.linkedin.com/company/flyhubinfo/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                <FaLinkedinIn />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/franchise">Franchise</Link></li>
              <li><Link to="/features">Features</Link></li>
              <li><Link to="/categories">Categories</Link></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Combined Contact & Legal + Powered By section */}
          <div className="footer-section combined-section">
            <div className="combined-content">
              {/* Contact & Legal section */}
              <div className="contact-legal-section">
                <h4>Contact & Legal</h4>
                <ul>
                  <li className="contact-item">
                    <FaEnvelope className="contact-icon" />
                    <span>support@flyhub.info</span>
                  </li>
                  <li className="contact-item">
                    <FaPhone className="contact-icon" />
                    <span>+91 9150739434</span>
                  </li>
                  <li className="contact-item">
                    <FaMapMarkerAlt className="contact-icon" />
                    <span>Manickampalayam, Tiruchengode, Tamil Nadu 637202</span>
                  </li>
                  <li className="legal-links">
                    <Link to="/terms">Terms & Conditions</Link>
                    <span className="separator">|</span>
                    <Link to="/privacy">Privacy Policy</Link>
                    <span className="separator">|</span>
                    <Link to="/shipping">Shipping Policy</Link>
                    <span className="separator">|</span>
                    <Link to="/refund">Refund Policy</Link>
                  </li>
                </ul>
              </div>

              {/* Powered by Aviatricks section - RIGHT NEXT TO IT */}
              <div className="powered-by-section">
                <div className="powered-by">
                  <span className="powered-by-text">Powered by</span>
                  <a
                    href="https://aviatricks.in"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="aviatricks-link"
                    aria-label="Visit Aviatricks website"
                  >
                    <img
                      src="/images/Aviatricks_logo.png"
                      alt="Aviatricks Logo"
                      className="aviatricks-logo"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Get Our App</h4>
            <a 
              href="https://play.google.com/store/apps/details?id=aviatricks.flyhub&pcampaignid=web_share" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="google-play-link"
            >
              <div className="google-play-badge">
                <img src="/images/playstore.png" alt="Play Store" className="google-play-icon" style={{ width: '24px', height: '24px', objectFit: 'contain', marginRight: '10px' }} />
                <div className="google-play-text">
                  <span className="google-play-small">GET IT ON</span>
                  <span className="google-play-large">Google Play</span>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">&copy; 2025 Flyhub. All rights reserved.</p>
            <p className="design-credit">Designed for drone enthusiasts and professionals</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;